import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Link } from 'react-router-dom';

const NRIConnectPage = () => {
  const faqs = [
    {
      question: "Can NRIs invest in Indian mutual funds?",
      answer: "Yes, NRIs can invest in Indian mutual funds, subject to compliance with the Foreign Exchange Management Act (FEMA) and other regulations laid down by SEBI (Securities and Exchange Board of India)."
    },
    {
      question: "What types of accounts do NRIs need to invest in mutual funds in India?",
      answer: "NRIs need to have either a NRE (Non-Resident External) or NRO (Non-Resident Ordinary) bank account. Investments can be made through these accounts or via FCNR (Foreign Currency Non-Repatriable) accounts."
    },
    {
      question: "Can NRIs repatriate their mutual fund investments?",
      answer: "Yes, investments made through an NRE or FCNR account are fully repatriable. Investments made through an NRO account are repatriable up to a limit set by the RBI."
    },
    {
      question: "Is PAN mandatory for NRIs to invest in mutual funds in India?",
      answer: "Yes, NRIs must have a Permanent Account Number (PAN) to invest in mutual funds in India."
    },
    {
      question: "How are mutual fund investments taxed for NRIs?",
      answer: "Taxation for NRIs depends on the type of mutual fund. Equity mutual funds are taxed at 15% for short-term gains (if held for less than one year) and 10% for long-term gains (above ₹1 lakh, held for more than one year). Debt funds attract 30% short-term capital gains tax and 20% long-term tax with indexation."
    },
    {
      question: "Are SIPs (Systematic Investment Plans) available for NRIs?",
      answer: "Yes, NRIs can start SIPs in mutual funds. They can invest regularly through SIPs by setting up automatic debits from their NRE/NRO accounts."
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-black via-gray-900 to-black">
      <Navbar />
      
      <div className="pt-32 pb-20 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6">
              NRI Connect
            </h1>
            <p className="text-lg text-white/70 max-w-3xl mx-auto">
              Tailored financial solutions for Non-Resident Indians. Expert guidance on managing wealth, building portfolios, and planning your financial future.
            </p>
          </div>

          {/* Services Overview */}
          <div className="grid md:grid-cols-2 gap-8 mb-20">
            <div className="bg-white/5 backdrop-blur-xl rounded-2xl p-8 border border-white/10">
              <h3 className="text-2xl font-bold text-white mb-4">✅ Taxation Advisory</h3>
              <p className="text-white/70">
                Expert guidance on DTAA benefits, capital gains, TDS management, and FATCA/CRS compliance to ensure you're tax-efficient in both India and your country of residence.
              </p>
            </div>

            <div className="bg-white/5 backdrop-blur-xl rounded-2xl p-8 border border-white/10">
              <h3 className="text-2xl font-bold text-white mb-4">✅ Investment Planning</h3>
              <p className="text-white/70">
                Tailored mutual fund portfolios through NRE/NRO accounts, SIP/STP setups, and goal-oriented strategies aligned with your risk profile and financial goals.
              </p>
            </div>

            <div className="bg-white/5 backdrop-blur-xl rounded-2xl p-8 border border-white/10">
              <h3 className="text-2xl font-bold text-white mb-4">✅ Regulatory Support</h3>
              <p className="text-white/70">
                Seamless onboarding with KYC for NRIs, FEMA-compliant documentation, and RBI-compliant investment routes via repatriable and non-repatriable options.
              </p>
            </div>

            <div className="bg-white/5 backdrop-blur-xl rounded-2xl p-8 border border-white/10">
              <h3 className="text-2xl font-bold text-white mb-4">✅ Estate Planning</h3>
              <p className="text-white/70">
                Structuring investments with clear nomination and transmission processes, will-based planning, and asset consolidation to ensure smooth generational transfer.
              </p>
            </div>
          </div>

          {/* FAQs Section */}
          <div className="mb-16">
            <h2 className="text-3xl lg:text-4xl font-bold text-white text-center mb-12">Frequently Asked Questions</h2>
            <div className="space-y-6">
              {faqs.map((faq, index) => (
                <div key={index} className="bg-white/5 backdrop-blur-xl rounded-xl p-6 border border-white/10">
                  <h4 className="text-lg font-semibold text-white mb-3">{faq.question}</h4>
                  <p className="text-white/70">{faq.answer}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="text-center">
            <Link
              to="/contact"
              className="inline-block px-8 py-4 bg-white text-black font-semibold rounded-full hover:shadow-[0_0_30px_rgba(255,255,255,0.3)] transition-all duration-300"
            >
              Connect With Our NRI Experts
            </Link>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default NRIConnectPage;